import React from "react";

interface NearbyAirportsToggleProps {
  label: string; // e.g. "Departure Airports"
  enabled: boolean;
  onToggle: () => void;
}

const NearbyAirportsToggle: React.FC<NearbyAirportsToggleProps> = ({
  label,
  enabled,
  onToggle,
}) => (
  <div className="flex items-center gap-3 px-4 py-3 border border-[#E5E7EB] rounded-xl">
    <i
      className="st-flight text-white text-[16px] inline-block"
      style={{ transform: "rotate(-50deg)", WebkitTextStroke: "0.5px #737C8C" }}
    ></i>
    <div className="flex flex-col">
      <span className="text-[11px] text-[#6B7280] leading-tight">
        Include nearby
      </span>
      <span className="text-xs text-[#1F2937] font-semibold leading-tight">
        {label}
      </span>
    </div>
    <button
      type="button"
      onClick={onToggle}
      className={`relative ml-auto md:ml-0 inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ${
        enabled ? "bg-[#FBBF24]" : "bg-gray-300"
      }`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200 ${
          enabled ? "translate-x-6" : "translate-x-1"
        }`}
      />
    </button>
  </div>
);

export default NearbyAirportsToggle;
